import Tracked from '~/components/Tracked';

import type { Group } from './SocialMediaLinks';
import { SOCIAL_MEDIA_URLS } from './SocialMediaLinks';

const InstagramIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.09 5.51762C17.8527 5.51762 17.6207 5.588 17.4233 5.71985C17.226 5.85171 17.0722 6.03913 16.9813 6.2584C16.8905 6.47767 16.8668 6.71895 16.9131 6.95173C16.9594 7.1845 17.0736 7.39832 17.2415 7.56615C17.4093 7.73397 17.6231 7.84826 17.8559 7.89456C18.0887 7.94086 18.3299 7.9171 18.5492 7.82627C18.7685 7.73545 18.9559 7.58164 19.0878 7.3843C19.2196 7.18696 19.29 6.95495 19.29 6.71762C19.29 6.39936 19.1636 6.09413 18.9385 5.86909C18.7135 5.64405 18.4083 5.51762 18.09 5.51762ZM22.69 7.93762C22.6706 7.10792 22.5152 6.28702 22.23 5.50762C21.9757 4.84075 21.58 4.2369 21.07 3.73762C20.5748 3.22504 19.9696 2.83179 19.3 2.58762C18.5227 2.29378 17.7008 2.13483 16.87 2.11762C15.81 2.05762 15.47 2.05762 12.75 2.05762C10.03 2.05762 9.69 2.05762 8.63 2.11762C7.79915 2.13483 6.97734 2.29378 6.2 2.58762C5.53168 2.83427 4.92693 3.22718 4.43 3.73762C3.91743 4.23279 3.52418 4.83806 3.28 5.50762C2.98616 6.28496 2.82721 7.10677 2.81 7.93762C2.75 8.99762 2.75 9.33762 2.75 12.0576C2.75 14.7776 2.75 15.1176 2.81 16.1776C2.82721 17.0085 2.98616 17.8303 3.28 18.6076C3.52418 19.2772 3.91743 19.8824 4.43 20.3776C4.92693 20.8881 5.53168 21.281 6.2 21.5276C6.97734 21.8215 7.79915 21.9804 8.63 21.9976C9.69 22.0576 10.03 22.0576 12.75 22.0576C15.47 22.0576 15.81 22.0576 16.87 21.9976C17.7008 21.9804 18.5227 21.8215 19.3 21.5276C19.9696 21.2834 20.5748 20.8902 21.07 20.3776C21.5822 19.8802 21.9783 19.2758 22.23 18.6076C22.5152 17.8282 22.6706 17.0073 22.69 16.1776C22.69 15.1176 22.75 14.7776 22.75 12.0576C22.75 9.33762 22.75 8.99762 22.69 7.93762ZM20.89 16.0576C20.8827 16.6924 20.7678 17.3213 20.55 17.9176C20.3903 18.3528 20.1339 18.746 19.8 19.0676C19.4756 19.3981 19.0832 19.6541 18.65 19.8176C18.0537 20.0354 17.4248 20.1503 16.79 20.1576C15.79 20.2076 15.42 20.2176 12.79 20.2176C10.16 20.2176 9.79 20.2176 8.79 20.1576C8.13089 20.17 7.47459 20.0685 6.85 19.8576C6.43578 19.6857 6.06136 19.4304 5.75 19.1076C5.41809 18.7864 5.16484 18.3928 5.01 17.9576C4.76586 17.3528 4.63044 16.7096 4.61 16.0576C4.61 15.0576 4.55 14.6876 4.55 12.0576C4.55 9.42762 4.55 9.05762 4.61 8.05762C4.61448 7.40867 4.73295 6.76556 4.96 6.15762C5.13605 5.73553 5.40627 5.35928 5.75 5.05762C6.05381 4.71379 6.42929 4.44071 6.85 4.25762C7.45955 4.03766 8.102 3.9227 8.75 3.91762C9.75 3.91762 10.12 3.85762 12.75 3.85762C15.38 3.85762 15.75 3.85762 16.75 3.91762C17.3848 3.9249 18.0137 4.03986 18.61 4.25762C19.0644 4.42627 19.4723 4.70046 19.8 5.05762C20.1277 5.3648 20.3838 5.74035 20.55 6.15762C20.7723 6.76655 20.8873 7.4094 20.89 8.05762C20.94 9.05762 20.95 9.42762 20.95 12.0576C20.95 14.6876 20.94 15.0576 20.89 16.0576ZM12.75 6.92762C11.7358 6.92959 10.745 7.23214 9.90265 7.79704C9.06035 8.36193 8.40438 9.16381 8.01763 10.1014C7.63089 11.0389 7.53072 12.0701 7.72979 13.0645C7.92886 14.059 8.41824 14.9722 9.13608 15.6886C9.85392 16.405 10.768 16.8926 11.7629 17.0898C12.7577 17.2869 13.7887 17.1847 14.7255 16.7962C15.6623 16.4076 16.4629 15.7501 17.0261 14.9067C17.5894 14.0632 17.89 13.0718 17.89 12.0576C17.8913 11.3827 17.7592 10.7142 17.5012 10.0906C17.2433 9.46692 16.8646 8.90043 16.3869 8.42367C15.9092 7.94691 15.3419 7.5693 14.7178 7.31255C14.0936 7.0558 13.4249 6.92498 12.75 6.92762ZM12.75 15.3876C12.0914 15.3876 11.4476 15.1923 10.9 14.8264C10.3523 14.4605 9.92552 13.9404 9.67348 13.332C9.42144 12.7235 9.3555 12.0539 9.48398 11.408C9.61247 10.762 9.92963 10.1687 10.3953 9.70295C10.861 9.23724 11.4544 8.92009 12.1003 8.7916C12.7463 8.66311 13.4159 8.72906 14.0243 8.9811C14.6328 9.23314 15.1529 9.65995 15.5188 10.2076C15.8847 10.7552 16.08 11.399 16.08 12.0576C16.08 12.4949 15.9939 12.9279 15.8265 13.332C15.6592 13.736 15.4139 14.1031 15.1047 14.4123C14.7954 14.7215 14.4284 14.9668 14.0243 15.1341C13.6203 15.3015 13.1873 15.3876 12.75 15.3876Z"
      fill="#4B4B4B"
    />
  </svg>
);

const TikTokIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.9498 10.8979V8.05785C18.6198 8.05785 17.6048 7.70285 16.9498 7.01285C16.2775 6.22538 15.9009 5.22813 15.8848 4.19285V3.98785L13.1998 3.92285C13.1998 3.92285 13.1998 4.03785 13.1998 4.19285V15.4579C13.1077 15.9611 12.8634 16.424 12.4999 16.7841C12.1364 17.1441 11.6711 17.3839 11.167 17.4712C10.6628 17.5584 10.1441 17.4889 9.68068 17.272C9.21729 17.055 8.83157 16.7012 8.57573 16.2581C8.31988 15.8151 8.20607 15.3042 8.24981 14.7944C8.29355 14.2846 8.49249 13.8005 8.82001 13.4075C9.14753 13.0144 9.58777 12.7313 10.0813 12.5963C10.5748 12.4614 11.0979 12.4811 11.5798 12.6529V9.90285C11.2988 9.85681 11.0146 9.8334 10.7298 9.83285C9.7053 9.83285 8.70383 10.1367 7.85198 10.7058C7.00014 11.275 6.33621 12.084 5.94413 13.0306C5.55205 13.9771 5.44955 15.0186 5.64934 16.0234C5.84912 17.0282 6.34257 17.9512 7.06699 18.6757C7.79141 19.4001 8.71443 19.8934 9.71923 20.0933C10.724 20.2932 11.7656 20.1906 12.7121 19.7985C13.6586 19.4065 14.4676 18.7426 15.0368 17.8907C15.606 17.0389 15.9098 16.0374 15.9098 15.0129C15.9093 14.8006 15.8959 14.5885 15.8698 14.3779V9.80285C17.0907 10.5653 18.5112 10.9466 19.9498 10.8979Z"
      fill="#4B4B4B"
    />
  </svg>
);

const TwitterIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.7988 3.05762L10.5205 13.3824L2.75 21.7768H4.4988L11.3019 14.4273L16.7986 21.7768H22.75L14.5938 10.8713L21.827 3.05762H20.078L13.8124 9.82634L8.75009 3.05762H2.7988ZM5.37062 4.34581H8.10461L20.178 20.4884H17.4437L5.37062 4.34581Z"
      fill="#4B4B4B"
    />
  </svg>
);

const FacebookIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.643 14.9488L17.086 12.0581H14.312V10.1823C14.312 9.39148 14.7 8.62064 15.942 8.62064H17.203V6.15971C17.203 6.15971 16.059 5.9644 14.965 5.9644C12.68 5.9644 11.188 7.34877 11.188 9.85502V12.0581H8.648V14.9488H11.188V21.939C6.41 21.1877 2.75 17.0477 2.75 12.0581C2.75 6.53774 7.23 2.05774 12.75 2.05774C18.27 2.05774 22.75 6.53774 22.75 12.0581C22.75 17.0477 19.09 21.1877 14.312 21.939V14.9488H16.643Z"
      fill="#4B4B4B"
    />
  </svg>
);

type SocialStripProps = {
  className?: string;
  group: Group;
};

export default function SocialStrip({
  group,
  className = ''
}: SocialStripProps) {
  const urls = SOCIAL_MEDIA_URLS[group];

  return (
    <div className={`flex items-center gap-4 md:gap-6 ${className}`}>
      <Tracked.ExternalLink
        href={urls.instagram}
        name="SOCIAL_MEDIA_PROFILE"
        pagePosition="Social Media Carousel"
        variant="none"
        className="hover:opacity-70"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
      >
        <InstagramIcon />
      </Tracked.ExternalLink>
      <Tracked.ExternalLink
        href={urls.tiktok}
        name="SOCIAL_MEDIA_PROFILE"
        pagePosition="Social Media Carousel"
        variant="none"
        className="hover:opacity-70"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="TikTok"
      >
        <TikTokIcon />
      </Tracked.ExternalLink>
      <Tracked.ExternalLink
        href={urls.twitter}
        name="SOCIAL_MEDIA_PROFILE"
        pagePosition="Social Media Carousel"
        variant="none"
        className="hover:opacity-70"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="X (Twitter)"
      >
        <TwitterIcon />
      </Tracked.ExternalLink>
      <Tracked.ExternalLink
        href={urls.facebook}
        name="SOCIAL_MEDIA_PROFILE"
        pagePosition="Social Media Carousel"
        variant="none"
        className="hover:opacity-70"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
      >
        <FacebookIcon />
      </Tracked.ExternalLink>
    </div>
  );
}
